<template>
  <div :class="['wrap',$route.meta.hasHeaderFix?'has-header':'']">
    <page-header v-if="$route.meta.hasHeader"></page-header>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  components: {
    pageHeader: () => import('./header')
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang="less" scoped>

  .has-header{
    padding-top: 50px;
  }
</style>
